import { VueConstructor } from "vue/types/vue";
import { Store, createNamespacedHelpers } from "vuex";

const { mapGetters } = createNamespacedHelpers("team");

import TeamStore from "./store";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";

/// Register types

declare module "vue/types/vue" {
	interface Vue {
		$team: {
			fetch: (team: GetOneTeamResponse | null) => Promise<void>;
		};
		hasPermission: (permission: number) => boolean;
		hasFeaturePermission: (featurePermission: number) => boolean;
	}
}

export default {
	install(vue: VueConstructor, options: { store: Store<any> }) {
		/// Register stores
		if (!(options && options.store)) {
			throw new Error("Please provide vuex store.");
		}
		options.store.registerModule("team", TeamStore);

		/// Register components

		/// Register methods
		vue.prototype.$team = {
			fetch: async (team: GetOneTeamResponse | null) => {
				await options.store.dispatch("team/fetch", team);
			}
		};

		/// Register mixins
		vue.mixin({
			computed: {
				...mapGetters({
					hasPermission: "hasPermission",
					hasFeaturePermission: "hasFeaturePermission"
				})
			}
		});
	}
};